import { Config } from "@app/config";
import { faPaperPlane } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import type { LeadFormStepFields } from "@component/assets/AbstractLeadForm/Steps/BasicLeadForm";
import { BasicLeadForm } from "@component/assets/AbstractLeadForm/Steps/BasicLeadForm";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { __, FormRadio, getLocale, ProgressButton } from "@shared/ui";
import type { FormApi } from "final-form";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";

export const REQUEST_CONSULTANT_CALL_OPTIONS = [
	{
		label: "Szeretnék egy jó nyugdíj megoldást találni",
		value: "Szeretne szerződést",
	},
	{
		label: "Tudni szeretném, van-e jobb a meglévő termékemnél",
		value: "Van meglévő terméke, érdeklődik a váltás iránt",
	},
	{
		label: "Csak nézelődök",
		value: "Csak nézelődik",
	},
];

export interface StepFields {
	requestConsultantCall?: string;
	lastName: string;
	firstName: string;
	email: string;
	phone: string;
	cityName: string;
	cityId?: number;
}

export class LeadForm extends BasicLeadForm {
	public static defaultProps = {
		...BasicLeadForm.defaultProps,
		title: <>Kérd részletes eredményeidet email-ben!</>,
	};

	protected initValues(): StepFields {
		return {
			lastName: undefined,
			firstName: undefined,
			cityName: undefined,
			phone: undefined,
			email: undefined,
			cityId: undefined,
			requestConsultantCall: undefined,
		};
	}

	protected renderContent(
		_values: LeadFormStepFields,
		_form: FormApi<LeadFormStepFields, Partial<LeadFormStepFields>>,
	): ReactNode {
		const { submitState } = this.props;

		return (
			<>
				{this.renderHeader()}
				<Card.Body className="bg-transparent">
					{super.renderFields()}
					<FormRadio label="" name="requestConsultantCall" options={REQUEST_CONSULTANT_CALL_OPTIONS} />
				</Card.Body>
				<Card.Footer className="text-center bg-transparent">
					{this.renderPrivacyStatement()}
					<ProgressButton
						type="submit"
						variant="primary"
						className="font-weight-bold mt-2"
						state={submitState}
						disabled={super.isDisabled()}
						icon={<FontAwesomeIcon icon={faPaperPlane} />}
					>
						Eredmény küldése
					</ProgressButton>
				</Card.Footer>
			</>
		);
	}

	protected renderPrivacyStatement(): ReactNode {
		return (
			<div className="text-dark text-center fs-xs pt-2 mt-auto">
				{__("Megismertem és hozzájárulok az")}{" "}
				<a
					className="text-reset text-underline"
					href={Config.getBankmonitorUrl("/adatvedelem/")}
					target="_blank"
				>
					{__("Adatvédelmi szabályzatban")}
				</a>
				{getLocale() === "hu_HU" && " foglalt adatkezeléshez."}
			</div>
		);
	}

	renderHeader(): ReactNode {
		const { title } = this.props;

		if (!title) {
			return null;
		}

		return (
			<Card.Header className="bg-transparent">
				<Card.Title className="text-center">{title}</Card.Title>
			</Card.Header>
		);
	}

	protected getClassName(): string {
		return "small-calculator-step card";
	}

	protected getComponentName(): string {
		return `${super.getComponentName()}.LeadForm`;
	}
}
